<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <img :src="logo" style="max-width:50%;" class="mx-auto"/>
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Restablecer Contraseña</h4>
                  <p class="mb-0">Introduzca su nueva contraseña.</p>
                </div>
                <div class="card-body">
                  <form @submit.prevent="resetPassword" >
                    <div class="mb-3">
                      <argon-input
                      type="email" placeholder="Email"
                      name="email" size="lg"
                      :value="email"
                      disabled />
                    </div>
                    <div class="mb-3">
                      <argon-input
                      type="password" placeholder="Nueva Contraseña"
                      name="new_password" size="lg"
                      v-model="newPassword" />
                    </div>
                    <div class="mb-3">
                      <argon-input
                      type="password" placeholder="Confirmar Contraseña"
                      name="confirm_password" size="lg"
                      v-model="confirmPassword" />
                    </div>
                    <div class="text-center">
                      <argon-button
                        type="submit"
                        class="mt-4"
                        color="success"
                        fullWidth
                        size="lg"
                      >Restablecer y Acceder</argon-button>
                    </div>
                  </form>
                </div>
                </div>
            </div>
            </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import axios from 'axios';
import Swal from 'sweetalert2';
import logo from "@/assets/img/logo.png";
import { useRoute } from 'vue-router'; // Importar useRoute para obtener parámetros

const body = document.getElementsByTagName("body")[0];

export default {
  name: "PasswordReset", // Cambié el nombre del componente para claridad
  components: {
    ArgonInput,
    ArgonButton,
  },
  data() {
    return {
      logo,
      newPassword: null,
      confirmPassword: null,
    }
  },
  // Usamos setup() para usar useRoute()
  setup() {
    // Obtener los parámetros de la URL
    const route = useRoute();
    const token = route.query.token || null;
    const email = route.query.email ? decodeURIComponent(route.query.email) : null;

    return { token, email };
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");

    // Verificar si faltan parámetros críticos
    if (!this.token || !this.email) {
      Swal.fire({
        title: 'Error de Enlace',
        text: 'El enlace de restablecimiento es inválido o ha expirado.',
        icon: 'error',
        confirmButtonColor: '#bf4f51',
      }).then(() => {
        // Redirigir a una vista de inicio de sesión o solicitar recuperación de nuevo
        this.$router.push('/login');
      });
    }
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
  methods: {
    // Función para iniciar sesión (la misma que tenías)
    login(credentials) {
      let self = this;

      axios.post(self.$store.state.apiURL + 'login', credentials)
        .then((result) => {
          // ÉXITO: Almacenar datos y redirigir
          localStorage.setItem('userId', result.data.id);
          localStorage.setItem('userEmail', result.data.email);
          localStorage.setItem('userFullName', result.data.full_name);
          localStorage.setItem('userName', result.data.username);
          localStorage.setItem('userLevel', result.data.role_id);
          localStorage.setItem('accessToken', result.data.token);
          localStorage.setItem('companyId', result.data.company);

          Swal.fire({
              title: '¡Sesión Iniciada!',
              text: 'Tu contraseña ha sido restablecida e iniciaste sesión.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
          });
          self.$router.push('/');
        })
        .catch((err) => {
          console.error("Fallo de inicio de sesión automático:", err);
          Swal.fire({
            title: 'Error de Sesión',
            text: 'Contraseña restablecida, pero fallo al iniciar sesión. Intenta iniciar sesión manualmente.',
            icon: 'warning',
            confirmButtonColor: '#bf4f51',
          }).then(() => {
             // Redirigir al formulario de inicio de sesión manual
             self.$router.push('/signin');
          });
        });
    },

    // Función principal para restablecer la contraseña
    resetPassword() {
      let self = this;

      if (this.newPassword !== this.confirmPassword) {
        Swal.fire({
          title: 'Error',
          text: 'Las contraseñas no coinciden.',
          icon: 'warning',
          confirmButtonColor: '#bf4f51',
        });
        return;
      }

      if (!this.newPassword || this.newPassword.length < 6) { // Ajusta la validación de longitud
        Swal.fire({
          title: 'Error',
          text: 'La contraseña debe tener al menos 6 caracteres.',
          icon: 'warning',
          confirmButtonColor: '#bf4f51',
        });
        return;
      }

      // Datos a enviar al API para restablecer
      const resetData = {
        token: this.token,
        email: this.email,
        new_password: this.newPassword,
      };

      // 1. Llamar al endpoint de restablecimiento (ASUME que es 'reset-password' o similar)
      axios.post(self.$store.state.apiURL + 'password/reset', resetData)
        .then(() => {
          // ÉXITO: Contraseña restablecida. Ahora intentar iniciar sesión.
          const loginCredentials = {
            username: this.email, // Asumiendo que el campo 'username' acepta el email
            password: this.newPassword,
          };

          // 2. Intentar iniciar sesión automáticamente
          this.login(loginCredentials);

        })
        .catch((err) => {
          console.error("Fallo al restablecer la contraseña:", err);
          let errorMessage = 'Ha ocurrido un error al intentar restablecer la contraseña. El enlace puede ser inválido o haber expirado.';

          // Si el servidor proporciona un mensaje de error específico (ej. 400, 401), se puede usar
          if (err.response && err.response.data && err.response.data.message) {
              // Esto depende de cómo tu API maneje los errores de token/email
              errorMessage = err.response.data.message;
          }

          Swal.fire({
            title: 'Fallo de Restablecimiento',
            text: errorMessage,
            icon: 'error',
            confirmButtonColor: '#bf4f51',
          }).then(() => {
              // Redirigir por si tienen que volver a solicitar el restablecimiento
             //self.$router.push('/forgot-password-route');
          });
        });
    }
  }
};
</script>